module.exports = __webpack_public_path__ + "static/media/goods_title@2x.771a7b2c.png";